export var TypeActionChat;
(function (TypeActionChat) {
    TypeActionChat["ChatRoomInfoReceived"] = "Chat > ChatRoomInfoReceived";
    TypeActionChat["PostInChatRoom"] = "Chat > PostInChatRoom";
    TypeActionChat["AddNewMessageInChatRoom"] = "Chat > AddNewMessageInChatRoom";
    TypeActionChat["ResetUnreadMessageCount"] = "Chat > ResetUnreadMessageCount";
})(TypeActionChat || (TypeActionChat = {}));
export var actionChatRoomInfoReceived = function (chatRoom) { return ({
    chatRoom: chatRoom,
    type: TypeActionChat.ChatRoomInfoReceived,
}); };
export var actionChatPostInChatRoom = function (message) { return ({
    message: message,
    type: TypeActionChat.PostInChatRoom,
}); };
export var actionAddNewMessageInChatRoom = function (message, isChatTabOpen) {
    if (isChatTabOpen === void 0) { isChatTabOpen = false; }
    return ({
        isChatTabOpen: isChatTabOpen,
        message: message,
        type: TypeActionChat.AddNewMessageInChatRoom,
    });
};
export var actionResetUnreadMessageCount = function () { return ({
    type: TypeActionChat.ResetUnreadMessageCount,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/actionChat.ts
// module id = 551
// module chunks = 3